import { supabase, Tobacco } from './supabase';
import { getWeatherRecommendation, WeatherData } from './weather';

export async function getRecommendations(
  lat?: number,
  lon?: number,
  smokerType?: string,
  preferredPipeShapes?: string[],
  weatherOverride?: WeatherData
): Promise<Tobacco[]> {
  try {
    const weather = weatherOverride ?? await getWeatherRecommendation(lat, lon);
    const { temperature, humidity } = weather;

    const { data: tobaccos, error } = await supabase
      .from('tobaccos')
      .select('*');

    if (error || !tobaccos) {
      console.error('Error fetching tobaccos:', error);
      return [];
    }

    // Score each tobacco based on conditions
    const scored = tobaccos.map((tobacco) => {
      let score = 0;

      // Temperature-based scoring
      if (temperature !== null) {
        if (temperature > 25 && tobacco.strength === 'mild') score += 2;
        if (temperature < 10 && tobacco.strength === 'full') score += 2;
        if (temperature >= 10 && temperature <= 25 && tobacco.strength === 'medium') score += 1;
      }

      // Humidity penalty for dark blends
      if (humidity !== null && humidity > 80) {
        if (tobacco.flavor_tags.includes('dark')) score -= 1;
      }

      // Pipe shape preferences (for pipe smokers)
      if (
        smokerType !== 'cigar' &&
        preferredPipeShapes &&
        preferredPipeShapes.length > 0 &&
        tobacco.type === 'pipe'
      ) {
        // Virginia blends work well in billiard/straight pipes
        if (
          tobacco.flavor_tags.includes('virginia') &&
          preferredPipeShapes.includes('Billiard')
        ) {
          score += 1;
        }
        // English/Latakia blends good in bent pipes
        if (
          (tobacco.flavor_tags.includes('smoky') || tobacco.flavor_tags.includes('earthy')) &&
          preferredPipeShapes.includes('Bent')
        ) {
          score += 1;
        }
      }

      // Filter by smoker type
      if (smokerType === 'pipe' && tobacco.type !== 'pipe') score -= 100;
      if (smokerType === 'cigar' && tobacco.type !== 'cigar') score -= 100;

      return { tobacco, score };
    });

    // Sort by score and return top 5
    return scored
      .sort((a, b) => b.score - a.score)
      .slice(0, 10)
      .map((item) => item.tobacco);
  } catch (error) {
    console.error('Recommendations error:', error);
    return [];
  }
}

